export class GetProfile {
  static readonly type = '[ProfileState] Get Profile';
}

export class ChangePassword {
  static readonly type = '[ProfileState] Change Password';
  constructor(
    public userId: number,
    public password: string,
  ) {}
}

export interface UpdateProfilePayload {
  firstName: string;
  lastName: string;
  phone: string;
}

export class UpdateProfile {
  static readonly type = '[ProfileState] Update Profile';
  constructor(public payload: UpdateProfilePayload) {}
}

export class UpdateProfilePhoto {
  static readonly type = '[ProfileState] Update Profile Photo';
  constructor(public photoUrl: string) {}
}

export class UpdateActivePlan {
  static readonly type = '[ProfileState] Update Active Plan';
  constructor(public planId: string) {}
}
